import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  private isMobile = Capacitor.isNativePlatform();
  private inactiveHandled = false; // ensures single alert/logout

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.inactiveHandled) {
      return EMPTY;
    }

    return next.handle(request).pipe(
      catchError((err: any) => {
        if (environment.http_debug) console.log('HTTP error:', err);

        const inactiveError = err?.error?.errors?.find(
          (e: any) => e?.message === 'Context creation failed: INACTIVE'
        );

        if (inactiveError && !this.inactiveHandled) {
          this.inactiveHandled = true;

          window.alert('User is disabled. Please contact NEFCO Admin');

          if (this.isMobile) {
            this.authService.mobileLogout();
          } else {
            this.authService.logout();
          }
          return EMPTY;
        }
        return throwError(() => err);
      })
    );
  }
}
